import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from '../../Driveanalysis/NoData';
import ChartLoader from '../../Driveanalysis/ChartLoader';
import BuketsTableVehicle from '../BuketsTableVehicle';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import value from "wink-statistics/src/accessor";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function FastChargeDurationVehicle({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [check, SetCheck] = useState("median_20_100");
  const [chartname, SetChartName] = useState("Slow charge duration 20% - 100%");
  let barcolor

  let modal_title = "Slow Charge Duration 20% - 100%";
  let toPush = [];
  let toPushfast = [];
  const appyData = (data) => {
    res_result = data;
    toPush = [];
    let responce = {
      "<250": 0,
      "275": 0,
      "300": 0,
      "325": 0,
      "350": 0,
      "375": 0,
      "400": 0,
      "425": 0,
      "450": 0,
      "475": 0,
      "500": 0,
      "525": 0,
      "550": 0,
      "575": 0,
      ">=575": 0,
    }

    if (res_result.length !== 0) {

      SetApiResponce(res_result);

      let d = res_result[0];

      if (d.less375_400.value)
        responce["400"] = d.less375_400.value
      if (d.less250.value)
        responce["<250"] = d.less250.value
      if (d.less250_275.value)
        responce["275"] = d.less250_275.value
      if (d.less275_300.value)
        responce["300"] = d.less275_300.value
      if (d.less300_325.value)
        responce["325"] = d.less300_325.value
      if (d.less325_350.value)
        responce["350"] = d.less325_350.value
      if (d.less350_375.value)
        responce["375"] = d.less350_375.value
      if (d.less375_400.value)
        responce["400"] = d.less375_400.value
      if (d.less400_425.value)
        responce["425"] = d.less400_425.value
      if (d.less425_450.value)
        responce["450"] = d.less425_450.value
      if (d.less450_475.value)
        responce["475"] = d.less450_475.value
      if (d.less475_500.value)
        responce["500"] = d.less475_500.value
      if (d.less500_525.value)
        responce["525"] = d.less500_525.value
      if (d.less525_550.value)
        responce["550"] = d.less525_550.value
      if (d.less550_575.value)
        responce["575"] = d.less550_575.value
      if (d.gre575.value)
        responce[">=575"] = d.gre575.value


      toPush.push(d.less250.value)
      toPush.push(d.less250_275.value)
      toPush.push(d.less275_300.value)
      toPush.push(d.less300_325.value)
      toPush.push(d.less325_350.value)
      toPush.push(d.less350_375.value)
      toPush.push(d.less375_400.value)
      toPush.push(d.less400_425.value)
      toPush.push(d.less425_450.value)
      toPush.push(d.less450_475.value)
      toPush.push(d.less475_500.value)
      toPush.push(d.less500_525.value)
      toPush.push(d.less525_550.value)
      toPush.push(d.less550_575.value)
      toPush.push(d.gre575.value)
      SetfilteredData(toPush)

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<250", "275", "300", "325", "350", "375", "400", "425", "450", "475", "500", "525", "550", "575", ">=575"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          // res_result_final.push([x, responce[x], barcolor]);
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
      })
      const labels = ["<250", "275", "300", "325", "350", "375", "400", "425", "450", "475", "500", "525", "550", "575", ">=575"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Duration (Min)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const appyDataFast = (data) => {
    console.log("dadsadasds",data);
    res_result = data;
    toPush = [];
    toPushfast = []
    let responce = {
      "<70": 0,
      "80": 0,
      "90": 0,
      "100": 0,
      "110": 0,
      "120": 0,
      "130": 0,
      "140": 0,
      "150": 0,
      "160": 0,
      "170": 0,
      "180": 0,
      ">=180": 0,
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length !== 0) {
      SetApiResponce(res_result);

      let d = res_result[0];
      let id = 0
      if (d.less70.value > 0) {
        responce["<70"] = d.less70.value
      } if (d.less70_80.value > 0) {
        responce["80"] = d.less70_80.value
      } if (d.less80_90.value > 0) {
        responce["90"] = d.less80_90.value
      } if (d.less90_100.value > 0) {
        responce["100"] = d.less90_100.value
      } if (d.less100_110.value > 0) {
        responce["110"] = d.less100_110.value
      } if (d.less110_120.value > 0) {
        responce["120"] = d.less110_120.value
      } if (d.less120_130.value > 0) {
        responce["130"] = d.less120_130.value
      } if (d.less130_140.value > 0) {
        responce["140"] = d.less130_140.value
      } if (d.less140_150.value > 0) {
        responce["150"] = d.less140_150.value
      } if (d.less150_160.value > 0) {
        responce["160"] = d.less150_160.value
      } if (d.less160_170.value > 0) {
        responce["170"] = d.less160_170.value
      } if (d.less170_180.value) {
        responce["180"] = d.less170_180.value
      } if (d.greater_180.value) {
        responce[">=180"] = d.greater_180.value
      }
      toPushfast.push(d.less70.value)
      toPushfast.push(d.less70_80.value)
      toPushfast.push(d.less80_90.value)
      toPushfast.push(d.less90_100.value)
      toPushfast.push(d.less100_110.value)
      toPushfast.push(d.less110_120.value)
      toPushfast.push(d.less120_130.value)
      toPushfast.push(d.less130_140.value)
      toPushfast.push(d.less140_150.value)
      toPushfast.push(d.less150_160.value)
      toPushfast.push(d.less160_170.value)
      toPushfast.push(d.less170_180.value)
      toPushfast.push(d.greater_180.value)
      SetfilteredData(toPushfast)

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", ">=180"]

      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          // res_result_final.push([x, responce[x], barcolor]);
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
      })
      const labels = ["<70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", ">=180"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Duration (Min)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "OBC max temperature"
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,

    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Duration (Min)'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Duration (Min)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };

  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage/" + apiend, body: { filterdata: gloablfilter } }, appyData)
      SetCheck("median_20_100")
      SetChartName("Slow charge duration 20% - 100%");
      barcolor = "#348393"
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage/fastchargedurationdehiclefast", body: { filterdata: gloablfilter } }, appyDataFast)
      SetCheck(true)
      SetChartName("Fast charge duration 10% - 80%")
      barcolor = "#FFA650"
    }
  }, [gloablfilter, type])

  const appyDataClickFast = (data) => {
    let hits = data;
    hits.map((i, key) => {
      if (i.fields.FC10_80TimeInMin[0])
        toPushfast.push(i.fields.FC10_80TimeInMin[0])
    })
    SetfilteredData(toPushfast.sort())
  }

  const appyDataClick = (data) => {
    let hits = data;
    hits.map((i, key) => {
      if (i.fields.SC20_100TimeInMin[0]) {
        toPush.push(i.fields.SC20_100TimeInMin[0])
      }
    })
    SetfilteredData(toPush.sort())
  }

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;
            if (count !== 0) {
              if (check === "median_20_100") {

                if (barvalue === "<250") {
                  from_bucket = 0
                  to_bucket = 250
                } else if (barvalue === ">=575") {
                  from_bucket = 575
                  to_bucket = null

                } else {
                  from_bucket = barvalue - 25
                  to_bucket = barvalue
                }

                fetchData({ url: API_URL_MAIN + "chargingpage/duration_vehicle_click_slow", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
                window.$('#exampleModal__' + apiend).modal('show');
              }
              else {
                if (barvalue === "<70") {
                  from_bucket = 0
                  to_bucket = 70
                } else if (barvalue === ">=180") {
                  from_bucket = 180
                  to_bucket = null
                } else {
                  from_bucket = barvalue - 10
                  to_bucket = barvalue
                }

                fetchData({ url: API_URL_MAIN + "chargingpage/duration_vehicle_click_fast", body: { filterdata: gloablfilter, type: "Fast", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClickFast)
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableVehicle data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FastChargeDurationVehicle;